<template>
<div >

  <label style="font-size:40px;"> Ultimas requisiciones  </label>
  <span class="tag is-link is-large"> {{requisiciones.length}} </span>

    <div v-if="requisiciones.length == 0 ">
      <label style="color:red; font-size:32px;" > No hay nuevas requisiciones  </label>
    </div>

    <div v-else>

      <table class=" table is-striped is-narrow is-hoverable is-fullwidth " >
        <thead>
          <tr>
            <th><abbr title="Position">#</abbr></th>
            <th><abbr title="Position">Fecha</abbr></th>
            <th><abbr title="Goals against">El Gerente de : </abbr></th>
            <th><abbr title="Goal difference">Solicita Puesto : </abbr></th>
            <th><abbr title="Goal difference">Salario estimado</abbr></th>
            <th><abbr title="Points">requisitos</abbr></th>
            <th>  </th>
          </tr>
        </thead>
        <tbody>
           <tr  v-for="reque in requisiciones">
             <td> {{reque.id}} </td>
             <td v-html="parseDate(reque.fecha )"> </td>
             <td> {{reque.gerente}} </td>
             <td> {{reque.puesto_requerido}} <br><br>  <b> X {{ reque.vacantes }} </b>  </td>
             <td v-html="getSueldo(reque.puestos_id)" >  </td>
             <td> <textarea class="textarea" > {{reque.requisitos}}  </textarea> </abbr></td>
             <td v-if="$can('sendProcess', $cookies.get('RhSession').rol )" > <a class="button is-warning" @click="changeStatus(reque.id)">Enviar a en proceso</a> </td>
             <td v-else > <a class="button is-warning" disabled >Enviar a en proceso</a> </td>
           </tr>
         </tbody>

      </table>

    </div>
</div>
</template>

<script>

import axios from 'axios'
import Cors from 'cors'
import moment from 'moment'
import searchMix from '@/components/mixins/mixin'

import { EventBus } from '@/components/bus.js';

export default {
  data () {
    return {
      menuComponente: 'app-create',
      requisiciones: [],
      requisitos: '',
      fechahoy: '',
      salarios: []
    }
  },
  created () {
    this.getRequisiciones()
  },
  methods: {
    parseDate:function(data){
      return moment(data,'YYYY-MM-DD').format('DD-MM-YYYY')
    },
    getSueldo: function (indice) {
      console.log('funcion getsuledo ' + indice)

      return '$ 0.00' + ' - ' + '$ 2500.00'
    },
    getSalarios: function () {

    },
    changeStatus: function (id) {
      var estancia = this
      // axios.get(`/api/recursos_humanos_jean/rh-vue/conexion/assignFunction.php?action=sendReq&status_requisicion=2&id=${id}`)

      this.insertRegistro($cookies.get('RhSession').name, 'requisicion' , id, ' se envia a proceso  ', ' - ');

      axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/update', {
        table: 'requisicion',
        set: 'status_requisicion_id = 1 ',
        where: 'id = ' + id
      })
        .then(function (response) {
          if (response.status == 200) {
            estancia.getRequisiciones()

            estancia.$snotify.success('Requisicion Enviada a proceso ', 'Actualizado', {
              timeout: 3000,
              showProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true
            })
            EventBus.$emit('cambioCompon', 5, 'app-process'); //cambiamos de componente


          } else {
            console.log('error')
          }
        })
    },
    getRequisiciones: function () {
      var estancia = this
      // axios.get(`/api/recursos_humanos_jean/rh-vue/conexion/assignFunction.php?action=getFromWhere&table=requisicion&where=${where}`)
      axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/read', {
        select: '*',
        table: 'requisicion',
        where: "id <> '' AND status_requisicion_id = 0",
        condition: 'ORDER BY fecha DESC'
      })
        .then(function (response) {
          if (response.status == 200) {
            console.log(typeof (response.data.data))
            estancia.requisiciones = response.data
            console.log(response)
          } else {
            console.log('error')
          }
        })
    }
  },
  mixins: [searchMix]

}
</script>
